import { render, staticRenderFns } from "./PointsByWilaya.vue?vue&type=template&id=03c411fc"
import script from "./PointsByWilaya.vue?vue&type=script&lang=js"
export * from "./PointsByWilaya.vue?vue&type=script&lang=js"
import style0 from "./PointsByWilaya.vue?vue&type=style&index=0&id=03c411fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports